import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faChevronLeft,
  faChevronRight,
  faHashtag,
  faPlus,
  faRotate,
  faSave,
} from '@fortawesome/free-solid-svg-icons'
import { Collapse, Slider } from 'antd'
import { GridMalha } from '../../gerarMalha'
import React, { useEffect } from 'react'
import { gerarGrid } from '../../../meta'
import * as turf from '@turf/turf'
import { errorAlert, loadingAlert } from '../../../../../../utils/alert'
import { Render } from '../../../../../../Components/CustomUi/render'
import { UploadFileCustom } from '../../../../../../Components/CustomUi/uploadFileCustom'
import { Inline } from '../../../../../../Components/CustomUi/inline'
import Input from '../../../../../../Components/CustomUi/input'
import ButtonCustom from '../../../../../../Components/ButtonCustom'
import { Warning } from '../../../../../../Components/CustomUi/warning'
import { Switcher } from '../../../../../../Components/CustomUi/Switcher'
import { Box } from '../../../../../../Components/CustomUi/box'

interface PropsMapa {
  aoCarregarArquivo: (rawData: string, base64Data: string) => void
  validoFile: boolean
  rotation: number
  setRotation: React.Dispatch<React.SetStateAction<number>>
  rotacaoInput: string
  setRotacaoInput: React.Dispatch<React.SetStateAction<string>>
  gridLevel: string
  setGridLevel: React.Dispatch<React.SetStateAction<string>>
  position: { x: 0; y: 0 }
  setPosition: React.Dispatch<React.SetStateAction<{ x: number; y: number }>>
  movendo: boolean
  setMovendo: React.Dispatch<React.SetStateAction<boolean>>
  loading: string
  setLoading: React.Dispatch<React.SetStateAction<string>>
  editandoKml: boolean
  setEditandoKml: React.Dispatch<React.SetStateAction<boolean>>
  setGrid: React.Dispatch<React.SetStateAction<GridMalha[]>>
  setGridOriginal: React.Dispatch<React.SetStateAction<GridMalha[]>>
  setGridOriginalRotacao: React.Dispatch<React.SetStateAction<GridMalha[]>>
  setTamanhoGridOriginal: React.Dispatch<React.SetStateAction<number>>
  setQuadrante: React.Dispatch<React.SetStateAction<number>>
  areaHectares: number
  polygon: turf.Feature
  grid: GridMalha[]
  area: any[]
  kmlComCruzamento: boolean
  salvarContorno: () => void
}

export const AbaMapa: React.FC<PropsMapa> = React.memo(({
  aoCarregarArquivo,
  validoFile,
  rotation,
  setRotation,
  rotacaoInput,
  setRotacaoInput,
  gridLevel,
  setGridLevel,
  position,
  setPosition,
  movendo,
  setMovendo,
  loading,
  setLoading,
  setGrid,
  setGridOriginal,
  setGridOriginalRotacao,
  setTamanhoGridOriginal,
  setQuadrante,
  areaHectares,
  editandoKml,
  setEditandoKml,
  polygon,
  area,
  grid,
  kmlComCruzamento,
  salvarContorno,
}) => {
  const { Panel } = Collapse

  function adicionar(valor) {
    setMovendo(true)
    setRotation(valor + 1)
    setRotacaoInput(String(valor + 1))
  }

  function diminuir(valor) {
    setMovendo(true)
    setRotation(valor - 1)
    setRotacaoInput(String(valor - 1))
  }

  const valorDaRotacao = (e) => {
    const entrada = e
    if (entrada === '' || entrada === '-' || /^-?\d*\.?\d*$/.test(entrada)) {
      const num = parseFloat(entrada)
      if (isNaN(num)) {
        setRotacaoInput(entrada)
      } else {
        if (num >= -180 && num <= 180) {
          setRotacaoInput(entrada)
        } else {
          errorAlert('Limite excedido de rotação! limite é de -180 a 180')
        }
      }
    }
  }

  function tranformarEmNumber(valor: string): number | null {
    const normalizado = valor.trim().replace(',', '.').replace(/[^\d.-]/g, '')
    const numeroValido = /^-?\d+(\.\d+)?$/.test(normalizado)
    if (!numeroValido) return null
    const numero = Number(normalizado)
    return isNaN(numero) ? null : numero
  }

  function esconderMalha(cod) {
    const aba = cod[0]
    if (aba !== undefined) {
      setMovendo(true)
    }
  }

  function handleChange(valor) {
    let entrada = valor
    entrada = entrada.replace(',', '.')
    if (/^\d*\.?\d*$/.test(entrada)) {
      setGridLevel(entrada)
    }
  }

  useEffect(() => {
    if (rotacaoInput !== null) {
      const numero = tranformarEmNumber(rotacaoInput)
      setRotation(numero === null ? 0 : numero)
    }
    if (rotacaoInput === null) {
      setRotation(0)
    }
  }, [rotacaoInput])

  useEffect(() => {
    if (movendo) {
      setRotacaoInput(String(rotation))
    }
  }, [rotation])

  useEffect(() => {
    if (loading === 'l') {
      loadingAlert({ msg: 'Gerando grid...', id: 'loading' })
      setTimeout(() => { setLoading('g') }, 300)
    }
    if (loading === 'g') {
      gerarGrid(
        Number(gridLevel),
        polygon,
        areaHectares,
        setGrid,
        setGridOriginal,
        setGridOriginalRotacao,
        setTamanhoGridOriginal,
        setLoading,
        setQuadrante
      )
    }
  }, [loading])

  const handleFile = (files: File[]) => {
    const file = files[0]
    if (!file) return

    if (!file.name.toLowerCase().endsWith('.kml')) {
      errorAlert('O arquivo deve ser um KML válido.')
      return
    }

    const reader = new FileReader()
    reader.onload = async (event) => {
      const content = event.target?.result as string

      const toBase64 = (file: File) => {
        return new Promise<string>((resolve, reject) => {
          const readerBase64 = new FileReader()
          readerBase64.readAsDataURL(file)
          readerBase64.onload = () => resolve(readerBase64.result as string)
          readerBase64.onerror = (error) => reject(error)
        })
      }

      const base64Data = await toBase64(file)
      const formattedBase64 = `data:@file/xml;base64,${base64Data.replace('data:', '').replace(/^.+,/, '')}`

      aoCarregarArquivo(content, formattedBase64)
    }
    reader.readAsText(file)
  }

  return (
    <>
      <UploadFileCustom
        label="Carregar KML"
        accept=".kml"
        onFileSelect={handleFile}
      />

      <Render condition={kmlComCruzamento}>
        <Switcher
          label="Editar contorno"
          isChecked={editandoKml}
          trigger={() => setEditandoKml(!editandoKml)}
        />
      </Render>

      <Render condition={editandoKml}>

        <Warning style={{ fontSize: 11 }} type='warning'>
          Arraste os vértices do contorno para corrigir as sobreposições. Ao finalizar, clique em "Salvar contorno".
        </Warning>

      </Render>

      <Render condition={!editandoKml}>
        <Inline>
          <Input
            label='Tamanho do grid'
            placeholder={''}
            value={gridLevel}
            onChange={handleChange}
            icon={faHashtag}
            desabilitado={area.length <= 0 || kmlComCruzamento}
          />
          <ButtonCustom
            onClick={() => setLoading('l')}
            style={{ marginTop: '30px' }}
            icon={<FontAwesomeIcon icon={faPlus} />}
            disabled={area.length <= 0 || kmlComCruzamento}
            loading={loading === 'l'}
          >
            Gerar
          </ButtonCustom>
        </Inline>

        <div
          onMouseEnter={() => setMovendo(true)}
          onMouseLeave={() => setMovendo(false)}
          style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
        >
          <Collapse accordion destroyInactivePanel onChange={esconderMalha}>
            <Panel header={'Rotação'} key={1}>
              <Input
                placeholder={'Digite a rotação'}
                value={rotacaoInput}
                onChange={(e) => valorDaRotacao(e)}
                max={180}
                min={-180}
                desabilitado={grid.length <= 0 || kmlComCruzamento}
                icon={faRotate}
              />
              <Slider
                min={-180}
                max={180}
                step={1}
                value={rotation}
                onChange={(e) => setRotation(e)}
                style={{ width: '98%' }}
                disabled={grid.length <= 0 || kmlComCruzamento}
              />
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <div style={{ display: 'flex', gap: 5 }}>
                  <ButtonCustom
                    style={{ width: '20px', height: '30px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                    onClick={() => diminuir(rotation)}
                    icon={<FontAwesomeIcon icon={faChevronLeft} />}
                    disabled={grid.length <= 0 || kmlComCruzamento}
                  />
                  <ButtonCustom
                    style={{ width: '20px', height: '30px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                    onClick={() => adicionar(rotation)}
                    icon={<FontAwesomeIcon icon={faChevronRight} />}
                    disabled={grid.length <= 0 || kmlComCruzamento}
                  />
                </div>
              </div>
            </Panel>
            <Panel header={'Posicionar'} key={2}>
              <div>
                <span style={{ fontSize: '12px' }}>Horizontal:</span>
                <Slider
                  min={-360}
                  max={360}
                  step={1}
                  value={position.x}
                  onChange={(value) => setPosition((prev) => ({ ...prev, x: value as number }))}
                  disabled={grid.length <= 0 || kmlComCruzamento}
                />
              </div>
              <div>
                <span style={{ fontSize: '12px' }}>Vertical:</span>
                <Slider
                  min={-360}
                  max={360}
                  step={1}
                  value={position.y}
                  onChange={(value) => setPosition((prev) => ({ ...prev, y: value as number }))}
                  disabled={grid.length <= 0 || kmlComCruzamento}
                />
              </div>
            </Panel>
          </Collapse>
          <Warning style={{ fontSize: 11 }} type='info'>
            Ao rotacionar ou posicionar, a malha será temporariamente ocultada para otimizar a visualização.
          </Warning>
        </div>
      </Render>
    </>
  )
})